import { createStore, getActionIds } from '../helpers/redux';
import Immutable, { Set } from 'immutable';
import { AuthActions } from '../actions/auth';
import { AccountActions } from '../actions/account';
import { ProjectActions } from '../actions/project';

const actions = getActionIds(AccountActions);
const authActions = getActionIds(AuthActions);
const projectActions = getActionIds(ProjectActions);

const initialState = Immutable.fromJS({
  accounts: {},
  users: {},
  currentAccountId: null,
});

export const accounts = createStore(initialState, {
  [authActions.getMeProjects.success]: (state, action) => {
    const projects = action.result.entities.projects;

    if (!projects) return state;

    const projectsByAccountId = Object.keys(projects).reduce((p, key) => {
      const c = projects[key];
      if (!p[c.account_id]) p[c.account_id] = Set();
      p[c.account_id].add(c.id);
      return p;
    }, {});

    // return state.setIn(['projects'], Immutable.fromJS(projectsByAccountId));
    return state.mergeDeep({
      projects: Immutable.fromJS(projectsByAccountId),
    });
  },

  [projectActions.importJSONProject.success]: (state, action) => {
    const accountId = action.args[0].accountId;
    const projectId = action.result.result;
    const updatedList = state
      .getIn(['projects', accountId], Set())
      .add(projectId);
    return state.mergeDeep({
      projects: {
        [accountId]: updatedList,
      },
    });
  },

  [projectActions.copyProject.success]: (state, action) => {
    const projectId = action.result.result;
    const accountId = action.args[2];
    const updatedList = state
      .getIn(['projects', accountId], Set())
      .add(projectId);
    return state.mergeDeep({
      projects: {
        [accountId]: updatedList,
      },
    });
  },

  [projectActions.deleteProject.success]: (state, action) => {
    const projectId = action.args[0];
    const accountId = action.args[1];
    // const x = state.getIn(['projects', accountId], Set());
    const updatedList = state
      .getIn(['projects', accountId], Set())
      .delete(projectId);
    // debugger;
    return state.mergeDeep({
      projects: {
        [accountId]: updatedList,
      },
    });
  },

  [projectActions.createProject.success]: (state, action) => {
    const accountId = action.args[0].account_id;
    const projectId = action.result.result;
    return state.mergeDeep({
      projects: {
        [accountId]: state.getIn(['projects', accountId], Set()).add(projectId),
      },
    });
  },

  [authActions.getMeAccounts.success]: (state, action) => {
    return state.mergeDeep({
      accounts: action.result.entities.accounts,
    });
  },

  [actions.getAccounts.success]: (state, action) =>
    state.mergeDeep({
      accounts: action.result.result.entities.accounts,
    }),

  [actions.setAccountId]: (state, action) =>
    state.mergeDeep({
      currentAccountId: action.accountId,
    }),

  [actions.createAccount.success]: (state, action) =>
    state.mergeDeep({
      accounts: action.result.entities.accounts,
    }),

  [actions.getAccount.success]: (state, action) =>
    state.mergeDeep({
      accounts: action.result.entities.accounts,
    }),

  [projectActions.getProjects.success]: (state, action) => {
    // const x = state.setIn(['projects', action.args[0]], action.result.result);
    // debugger;
    // return state.setIn(['projects', action.args[0]], Set(action.result.result));
    return state.mergeDeep({
      projects: {
        [action.args[0]]: Set(action.result.result),
      },
    });
  },

  [actions.getAccountUsers.begin]: state =>
    state.set('users', Immutable.fromJS({})),

  [actions.getAccountUsers.success]: (state, action) => {
    if (!action.result.entities.users) return state;
    const results = Immutable.fromJS(action.result.entities.users);
    return state.set('users', results);
  },
  // state.mergeDeep({
  //   users: action.result.entities.users,
  // }),

  [actions.addUser.success]: (state, action) => {
    const x = action.result.entities.users
      ? state.mergeDeep({
          users: action.result.entities.users,
        })
      : state;
    // console.log('x', x, state, action);
    return x;
  },

  [actions.removeUser.success]: (state, action) =>
    state.deleteIn(['users', action.args[1]]),

  [actions.changeUserRole.success]: (state, action) =>
    state.mergeDeep({
      users: { [action.args[1]]: { role: action.args[2] } },
    }),

  [actions.deleteAccount.success]: (state, action) => {
    const accountId = action.args[0];
    return state.deleteIn(['accounts', accountId]);
  },

  [actions.renameAccount.success]: (state, action) =>
    state.mergeDeep({
      accounts: action.result.entities.accounts,
    }),
});

export const accountsSelector = state => state.accounts.get('accounts');

export const currentAccountIdSelector = state =>
  state.accounts.get('currentAccountId');



// WEBPACK FOOTER //
// ./src/reducers/accounts.js